import * as update from "immutability-helper";
import * as DTOS from "../FeralScan.dtos";
import { DashboardAction, QUESTION_REFERENCE_DATA_SUCCESS, REFERENCE_DATA_REQUEST, REFERENCE_DATA_SUCCESS, IGetReferenceDataSuccessAction } from "../actions/dashboard.actions";


export type ReferenceDataState = {
    classifications: DTOS.Classification[];
    dateRanges: DTOS.OptionDateExtended[];
    plotStatuses: DTOS.PlotStatus[];
    surveys: DTOS.Survey[],
    types: DTOS.QuestionOption[];
    userPreference: DTOS.UserPreference;
    userHasAuthenticatedSession: boolean;
    websiteSettings: DTOS.WebsiteSettings;

    loading: boolean;
}

const initialState: ReferenceDataState = {
    classifications: [],
    dateRanges: [],
    plotStatuses: [],
    surveys: [],
    types: [],
    userPreference: undefined,
    userHasAuthenticatedSession: undefined,
    websiteSettings: undefined,

    loading: true,
};

export default function referenceData(state: ReferenceDataState = initialState, action) {
    switch (action.type) {
        case REFERENCE_DATA_REQUEST:
            return loadingData(state, true);
        case REFERENCE_DATA_SUCCESS:
            return updateResults(state, action);
        case QUESTION_REFERENCE_DATA_SUCCESS:
            return updateQuestions(state, action);
    }
    return state;
}

function loadingData(state: ReferenceDataState, isLoading: boolean) {
    const newState = update(state, {
        loading: { $set: isLoading }
    });
    return newState;
}

function updateResults(state: ReferenceDataState, action: IGetReferenceDataSuccessAction) {

    const types = action.response.types.sort(function (a, b) { return a.rank - b.rank });

    const newState = update(state, {
        classifications: { $set: action.response.classifications },
        dateRanges: { $set: action.response.dateRange },
        plotStatuses: { $set: action.response.plotStatuses },
        surveys: { $set: action.response.surveys },
        types: { $set: types },
        userPreference: { $set: action.response.userPreference },
        userHasAuthenticatedSession: { $set: action.response.userHasAuthenticatedSession },
        websiteSettings: { $set: action.response.websiteSettings },
    });
    
    return loadingData(newState, false);
}

function updateQuestions(state: ReferenceDataState, action: DashboardAction) {
    return update(state, {
        questions: { $set: action.questions }
    });
}


